<template>
  <div tabindex="0" @click="$emit('click')" @keydown.space.enter="$emit('click')" class="closebtn" role="button" aria-label="close">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4L20 20M4 20L20 4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="sass">
.closebtn
  position: relative
  width: 24px
  cursor: pointer
  &::before
    content: ''
    top: -15px
    right: -15px
    bottom: -15px
    left: -15px
  svg
    display: block
    stroke: colors.$brown
</style>